import script from "./AreaDistributionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AreaDistributionCard.vue?vue&type=script&setup=true&lang=js"

import "./AreaDistributionCard.vue?vue&type=style&index=0&id=84ea0172&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84ea0172"]])

export default __exports__